module.exports = __webpack_public_path__ + "nc_static/media/completed-register.81c70982.svg";